import React from "react";
import EditCalendarHome from "./components/EditCalendarHome";
import MainSection from "../../components/mainLayout/Main";
import SectionHeader from "../../components/sectionHeader/SectionHeader";
import Sidebar from "../../components/sidebar/Sidebar";

const EditCalendarEvent = () => {
  return (
    <>
      <Sidebar />
      <MainSection>
        <SectionHeader title="Edit Event" />
        <EditCalendarHome />
      </MainSection>
    </>
  );
};

export default EditCalendarEvent;
